<a target="_blank" [href]="url" title="پیغام به واتس‌اپ">
  <i class="fab fa-whatsapp f-green fs-xl"></i>
  <span *ngIf="label" class="mr-1">{{label}}</span>
</a>